import { createAction } from '@reduxjs/toolkit';
import { HighlightedObject, PipelineFeatureProperties, PointOGIMGeoJSONProperties, SourceIds } from '../../../types';

/** This file contains actions that will be handled by multiple slices to update their respective parts of the state. */

export const setOgiNearby = createAction<{
    longitude: number;
    latitude: number;
    sourceType?: SourceIds;
    ogimFeatures: PipelineFeatureProperties[] | PointOGIMGeoJSONProperties[];
}>('emissions/setOgiNearby');

/**
 * Undoes the set action for the ogi near feature
 */
export const resetOgiNearby = createAction('emissions/resetOgiNearby');

/** Zoom to locations */
export const zoomToPermianAreaEmissions = createAction('emissions/zoomToPermianAreaEmissions');

export const zoomToPermianPlumeEmissions = createAction('emissions/zoomToPermianPlumeEmissions');

export const zoomToPermianTarget = createAction('emissions/zoomToPermianTarget');

export const zoomToPermianTargetBroad = createAction('emissions/zoomToPermianTargetBroad');

export const zoomToPermianOilAndGas = createAction<{ filterExpanded: boolean }>('emissions/zoomToPermianOilAndGas');

/** Highlight related actions */
export const addOneMapFeatureHighlight = createAction<{
    layerId: string;
    objectId: string | null;
    object: HighlightedObject;
    coordinate?: number[];
}>('emissions/addOneMapFeatureHighlight');

export const addMultipleMapFeatureHighlights = createAction<{
    layerId: string;
    features: { index: number; objectId: string | null }[];
}>('emissions/addMultipleMapFeatureHighlights');

export const removeAllMapFeatureHighlights = createAction('emissions/removeAllMapFeatureHighlights');
